export default {
  construction: 'En construcción.',
  menu: {
    item1: 'Congreso',
    item2: 'Ubicación',
    item3: 'Envíos',
    item4: 'Suscripciones',
    item5: 'Fechas',
    item6: 'Noticias',
    items1: [
      { title: 'Presentación' },
      { title: 'Organización' },
      { title: 'Horario' },
      { title: 'Oradores Invitados' },
      { title: 'Comisión Científica' },
      { title: 'Anales' },
      { title: 'Certificados' },
    ],
    items3: [
      { title: 'Temas y tópicos' },
      { title: 'Envío de resúmenes' },
      { title: 'Resúmenes aceptados' },
      { title: 'Envío de artículos' },
      { title: 'Artículos aceptados' },
      { title: 'Instrucciones para las presentaciones' },
    ],
  },
  content: {
    items1: [
      {
        text: 'PLURIS representa la continuidad de la colaboración entre investigadores de Brasil y'
        + ' Portugal establecida desde 2005. Es una asociación multidisciplinar técnico-científica que'
        + ' reúne profesionales que actuan principalmente en los siguientes temas: Medio ambiente y'
        + ' energía; Ciudades innovadoras e inteligentes; Movilidad y transporte y Planificación regional'
        + ' y urbana. <br><br>'
        + 'Precedido por PLURIS 2018, celebrado en Coimbra (Portugal), el Congreso bienal tiene su'
        + ' novena edición, que será realizada en Brasil y originalmente se realizaría en la ciudad de'
        + ' Águas de Lindóia, en el período de 07 a 09 de abril de 2021. No obstante, a los efectos de la'
        + ' pandemia COVID-19, el congreso se realizará en formato digital. El evento está abierto a'
        + ' diferentes perfiles de participantes: investigadores, estudiantes y profesionales relacionados'
        + ' con los temas cubiertos. Su nueva edición en 2021 tiene como objetivo reforzar y enriquecer'
        + ' los contactos establecidos en ediciones anteriores e integrar nuevos participantes, cuyos'
        + ' trabajos académicos y profesionales se ajusten a las áreas temáticas del congreso. <br><br>'
        + 'El tema de PLURIS 2021, "Pequeñas ciudades, grandes desafíos, múltiples oportunidades"</i>,'
        + ' busca engrandecer a la gran mayoría de las ciudades en los territorios brasileños y'
        + ' portugueses. Se sabe que el proceso de urbanización a menudo se asocia con grandes'
        + ' centros urbanos, pero dicho proceso también ocurre en pequeñas ciudades demográficas.'
        + ' En consecuencia, estas ciudades también merecen atención en relación con la planificación'
        + ' de la vivienda, el saneamiento básico, la educación, la salud, la movilidad, la seguridad, la'
        + ' protección del medio ambiente y la preservación del patrimonio histórico y cultural, ya que'
        + ' estos aspectos interfieren con la calidad de vida de sus habitantes.<br><br>'
        + 'El desafío actual para las ciudades pequeñas es proporcionar un desarrollo urbano,'
        + ' ambiental, económico y cultural sostenible. Debido a su escala, menor extensión territorial y'
        + ' menor población, los municipios menores tienen el diferencial de otras ciudades para'
        + ' implementar acciones de planificación más efectivas, un factor que podría contribuir a'
        + ' garantizar una mejor calidad de vida para los ciudadanos.<br><br>'
        + 'Esperamos contar con su presencia en PLURIS 2021 digital.<br><br>'
        + 'Saludos desde la Coordinación Local,<br><br>'
        + 'Renata Cardoso Magagnin<br>'
        + 'Maria Solange Gurgel de Castro Fontes<br>'
        + 'Gustavo Garcia Manzato<br>'
        + 'Universidade Estadual Paulista Júlio de Mesquita Filho (UNESP)',
      },
      {
        text: '<b>COORDINACIÓN PERMANENTE DEL PLURIS</b><br><br>'
        + '<b>Coordinadores de Comisiones Científicas</b><br><br>'
        + 'PROF. DR. ANTÔNIO NÉLSON RODRIGUES DA SILVA<br>'
        + 'Universidade de São Paulo - BR<br>'
        + 'anelson@sc.usp.br<br><br>'
        + 'PROF. DR. RUI ANTÓNIO RODRIGUES RAMOS<br>'
        + 'Universidade do Minho - PT<br>'
        + 'rui.ramos@civil.uminho.pt<br><br>'
        + 'PROFA. DRA. LÉA CRISTINA LUCAS DE SOUZA<br>'
        + 'Universidade Federal de São Carlos - BR<br>'
        + 'leacrist@ufscar.br<br><br>'
        + '<b>Coordinador de apoyo à informática</b><br><br>'
        + 'PROF. DR. DANIEL SOUTO RODRIGUES<br>'
        + 'Universidade do Minho - PT<br>'
        + 'dsr@civil.uminho.pt<br><br><br>'
        + '<b>ORGANIZACIÓN Y COORDINACIÓN EJECUTIVA LOCAL</b><br><br>'
        + 'Renata Cardoso Magagnin<br>'
        + 'Maria Solange Gurgel de Castro Fontes<br>'
        + 'Gustavo Garcia Manzato<br>'
        + 'Universidade Estadual Paulista Júlio de Mesquita Filho (UNESP)<br>',
        title1: 'COORDINACIÓN PERMANENTE',
        title2: 'ORGANIZACIÓN Y COORDINACIÓN EJECUTIVA LOCAL',
        contentContinuation: '<br><br><b>DESARROLLO DE LA IDENTIDAD VISUAL - PLURIS 2020/2021</b><br><br>'
        + '<b>INKY DESIGN</b><br>'
        + 'Marina de Araujo (estudiante - creación)<br>'
        + 'Natália Schiavon (estudiante - creación)<br>'
        + 'Profa. Dra. Cássia Carrara Domiciano (Coordinación)<br>'
        + 'Profa. Dra. Fernanda Henriques (Coordinación)<br><br><br>'
        + '<b>DESARROLLO DEL SITIO WEB PLURIS 2020/2021</b><br><br>'
        + 'Bianca Dias Barbosa (estudiante)<br><br><br>'
        + '<b>SOPORTE CON HERRAMIENTAS DIGITALES</b><br><br>'
        + 'Cíntia Machado de Oliveira<br>',
      },
      {
        wednesday: 'MIÉRCOLES',
        thursday: 'JUEVES',
        friday: 'VIERNES',
        morning: 'M<br>A<br>Ñ<br>A<br>N<br>A',
        afternoon: 'T<br>A<br>R<br>D<br>E',
        evening: 'N<br>O<br>C<br>H<br>E',
        startingat17h: 'A partir de las 17h',
        schedule: [
          'Acreditación <br>Recepción de congresistas',
          'Sesiones temáticas <br>Sesión de póster',
          'Sesiones temáticas',
          '<b>Mini curso 1 <br> ou <br> Mini curso 2</b>',
          'Sesión de apertura<br>',
          'Coffee break',
          'Conferencia<br>',
          'Almuerzo',
          'Sesiones temáticas <br>Sesión de póster',
          'Sesión de clausura del congreso',
          'Café de cierre',
          'Cóctel de bienvenida',
          'Cena del congreso',
        ],
        text: 'Haga clic <a href="/programacao.pdf" download>aquí</a> para descargar el programa en PDF.',
      },
      {
        text: '',
      },
      {
        text: 'Ademir Paceli Barbassa<br>'
        + 'Adriana Capretz<br>'
        + 'Alan Ricardo da Silva<br>'
        + 'Alessandra Rodrigues Prata-Shimomura<br>'
        + 'Alexandre Marques<br>'
        + 'Ana Bastos<br>'
        + 'Ana Elisabete de Almeida Medeiros<br>'
        + 'Ana Maria Guerra Seráfico Pinheiro<br>'
        + 'Ana Paula Camargo Larocca<br>'
        + 'Anabela Salgueiro Narciso Ribeiro<br>'
        + 'Andrea Ribeiro<br>'
        + 'Anna Silvia Palcheco Peixoto<br>'
        + 'António Armando Lima Sampaio Duarte<br>'
        + 'António José Pais Antunes<br>'
        + 'António Manuel de Sousa Baltazar Mortal<br>'
        + 'Antonio Nelson Rodrigues da Silva<br>'
        + 'Arminda Maria Marques Almeida<br>'
        + 'Ary Ferreira da Silva<br>'
        + 'Augusto Brasil<br>'
        + 'Barbara Stolte Bezerra<br>'
        + 'Bernardo Arantes do Nascimento Teixeira<br>'
        + 'Bianca Carla Dantas de Araújo<br>'
        + 'Bruno Bertoncini<br>'
        + 'Caio Frederico E silva<br>'
        + 'Camila Mayumi Nakata-Osaki<br>'
        + 'Carlos Alberto Bragança dos Santos<br>'
        + 'Carmen Velásquez Marea<br>'
        + 'Cira Souza Pitombo<br>'
        + 'Claudia Cotrim Pezzuto<br>'
        + 'Cláudia Mariz de Lyra Barroso Krause<br>'
        + 'Daniel Souto Rodrigues<br>'
        + 'Denise Balestrero Menezes<br>'
        + 'Diogenes Cortijo Costa<br>'
        + 'Douglas Barreto<br>'
        + 'Eduardo Oliveira<br>'
        + 'Eliane Viviani<br>'
        + 'Elio Trusiani<br>'
        + 'Erich Kellner<br>'
        + 'Érico Masiero<br>'
        + 'Erika Cristine Kneib<br>'
        + 'Fabiana Serra de Arruda<br>'
        + 'Fabiola Aguiar<br>'
        + 'Fernando Cavalcanti<br>'
        + 'Flávia Araújo<br>'
        + 'Francisco Manuel Camarinhas Serdoura<br>'
        + 'Fred Rodrigues<br>'
        + 'Frederico Yuri Hanai<br>'
        + 'Geovany Jessé Alexandre da Silva<br>'
        + 'Gianna Melo Barbirato<br>'
        + 'Gustavo Garcia Manzato<br>'
        + 'Ilce Marilia Dantas Pinto<br>'
        + 'Ilza Machado Kaiser<br>'
        + 'Irineu da Silva<br>'
        + 'Jefferson Oliveira Goulart<br>'
        + 'João Carlos<br>'
        + 'João Roberto Gomes de Faria<br>'
        + 'José Alberto Tostes<br>'
        + 'José Aparecido Sorratini<br>'
        + 'José da Costa Marques Neto<br>'
        + 'José Leomar Fernandes Júnior<br>'
        + 'José Manuel Ferreira da Silva<br>'
        + 'Josiane Palma Lima<br>'
        + 'Júlia Maria Brandão Barbosa Lourenço<br>'
        + 'Juliana Michaello<br>'
        + 'Karin Regina de Castro Marins<br>'
        + 'Léa Cristina Lucas de Souza<br>'
        + 'Leandro Cardoso<br>'
        + 'Lenise Grando Goldner<br>'
        + 'Leonardo Herszon Meira<br>'
        + 'Leonardo Marques Monteiro<br>'
        + 'Licinio da Silva Portugal<br>'
        + 'Lígia Conceição<br>'
        + 'Lindon Fonseca Matias<br>'
        + 'Lúcia Hidaka<br>'
        + 'Luzenira Alves Brasileiro<br>'
        + 'Magaly Romão<br>'
        + 'Maisa Tobias<br>'
        + 'Manuela Fernanda Gomes Moreira da Silva<br>'
        + 'Marcio Dagosto<br>'
        + 'Marcos Thadeu Queiroz Magalhães<br>'
        + 'María José Prados<br>'
        + 'Maria Manuela de Oliveira Guedes de Almeida<br>'
        + 'Maria Manuela Rosa<br>'
        + 'Maria Manuela Santos Natário<br>'
        + 'Maria Solange Gurgel de Castro Fontes<br>'
        + 'Maria Teresa Françoso<br>'
        + 'Mario Angelo Nunes de Azevedo Filho<br>'
        + 'Marta Cristina de Jesus Albuquerque Nogueira<br>'
        + 'Mateus Araujo e Silva<br>'
        + 'Mauro Normando Macêdo Barros Filho<br>'
        + 'Nair Cristina Margarido Brondino<br>'
        + 'Nívea Adriana Dias Pons<br>'
        + 'Norma Regina Truppel Constantino<br>'
        + 'Nuno Pinto<br>'
        + 'Orlando Strambi<br>'
        + 'Oswaldo Cavalcanti da Costa Lima Neto<br>'
        + 'Pablo Brilhante de Sousa<br>'
        + 'Paula Remoaldo<br>'
        + 'Paulo César Lima Segantine<br>'
        + 'Paulo Jorge Gomes Ribeiro<br>'
        + 'Paulo Roberto Masseran<br>'
        + 'Renata Cardoso Magagnin<br>'
        + 'Renato da Silva Lima<br>'
        + 'Ricardo Trevisan<br>'
        + 'Rodrigo Nóbrega<br>'
        + 'Rômulo José da Costa Ribeiro<br>'
        + 'Ronaldo Balassiano<br>'
        + 'Rui António Rodrigues Ramos<br>'
        + 'Rui Gama Fernandes<br>'
        + 'Samir Hernandes Tenorio Gomes<br>'
        + 'Sandra Regina Mota Silva<br>'
        + 'Sérgio Gomes<br>'
        + 'Sérgio Luiz Garavelli<br>'
        + 'Sidnei Pereira da Silva<br>'
        + 'Simone Becker Lopes<br>'
        + 'Teresa Cristina de Almeida Faria<br>'
        + 'Vasco Barbosa<br>'
        + 'Waldemir Rodrigues Costa Júnior<br>'
        + 'Waldir José Gaspar<br>'
        + 'Wellington Mary<br>',
      },
      {
        text: 'Haga clic <a href="/anais.pdf" download>aquí</a> para acceder a la versión final de las Actas.',
      },
      {
        text: 'Clique <a href="/certificados.pdf" download>aqui</a> para acessar os certificados do PLURIS 2021.',
      },
    ],
    items2: [
      {
        text: '<b>Congreso digital</b><br><br>'
        + 'PLURIS 2021 se realizará en formato digital.<br><br>'
        + 'Accede <a href="https://plurisdigital.ciente.live/login/" target="_blank">aquí</a> para la plataforma de actividades del congreso.',
      },
    ],
    items3: [
      {
        text: '<b>TEMAS</b><br><br>'
        + '<b>1. MEDIO AMBIENTE Y ENERGÍA</b> <br>'
        + '<b>2. CIUDADES INNOVADORAS E INTELIGENTES</b> <br>'
        + '<b>3. MOVILIDAD Y TRANSPORTE</b> <br>'
        + '<b>4. PLANIFICACIÓN REGIONAL Y URBANA</b> <br><br>'
        + '<b>TÓPICOS RELACIONADOS CON TEMAS</b> <br><br>'
        + '01 Accesibilidad urbana y movilidad<br>'
        + '02 Algoritmos genéticos<br>'
        + '03 Ambiente del espacio construido<br>'
        + '04 Análisis espacial<br>'
        + '05 Aspectos ambientales del transporte<br>'
        + '06 Autómatos celulares<br>'
        + '07 Ciudades y regiones digitales<br>'
        + '08 Clima y planificación urbana<br>'
        + '09 Confort ambiental en espacios urbanos<br>'
        + '10 Ecología urbana<br>'
        + '11 Educación y transferencia de tecnología<br>'
        + '12 Energía y planificación urbana<br>'
        + '13 Ergodesign y su uso en los espacios urbanos<br>'
        + '14 Estadística espacial<br>'
        + '15 Geomántica aplicada y gestión del territorio<br>'
        + '16 Gestión ambiental<br>'
        + '17 Gestión de infraestructuras<br>'
        + '18 Logística<br>'
        + '19 Inclusividad de los espacios urbanos<br>'
        + '20 Integración entre uso del suelo y transportes<br>'
        + '21 Planificación asistida por computador<br>'
        + '22 Planificación y gestión del uso del suelo<br>'
        + '23 Planificación, organización y sostenibilidad en eventos<br>'
        + '24 Planificación sustentable<br>'
        + '25 Calidad de vida urbana<br>'
        + '26 Problemáticas socioeconómicas<br>'
        + '27 Redes neuronales artificiales<br>'
        + '28 Rehabilitación ambiental urbana<br>'
        + '29 Simulaciones ambientales<br>'
        + '30 Sistemas de apoyo a la toma de decisiones<br>'
        + '31 Sistemas de apoyo a la planificación<br>'
        + '32 Sistemas de emergencia y seguridad en el medio urbano<br>'
        + '33 Sistemas de información<br>'
        + '34 Sistemas de información geográfica<br>'
        + '35 Sistemas de posicionamiento global<br>'
        + '36 Sostenibilidad en transportes<br>'
        + '37 Turismo y espacio urbano<br>'
        + '38 Efectos urbanos y regionales y políticas públicas derivadas de COVID-19<br>',
      },
      {
        text: '<b>NUEVA LLAMADA PARA ARTÍCULOS</b><br><br>'
        + 'Solamente para el tema: <b>""Efectos urbanos y regionales y políticas'
        + ' públicas derivadas de COVID-19"</b>.<br><br>'
        + 'Los resúmenes deben presentarse el <b>1 de junio el 2020.</b><br><br>'
        + 'Los resúmenes deben tener entre 300 y 500 palabras y describir claramente la naturaleza,'
        + ' relevancia y objetivos del trabajo, la metodología, modelo o técnica utilizada y los'
        + ' resultados.<br><br>'
        + 'El formulario para la presentación de resúmenes está disponible en: <u><a target="_blank" href="http://www.civil.uminho.pt/planning/pluris2020/subm_resumos/resumos_covid.aspx ">'
        + ' http://www.civil.uminho.pt/planning/pluris2020/subm_resumos/resumos_covid.aspx</a></u><br><br>',
      },
      {
        text: 'La lista de resumos aceptados se encuentra en: <br>'
        + '<u><a target="_blank" href="http://civil.uminho.pt/planning/pluris2020/lista_de_resumos_aprovados_2020_ES.pdf">'
        + ' http://civil.uminho.pt/planning/pluris2020/lista_de_resumos_aprovados_2020_ES.pdf</a></u><br><br>'

        + '<b>La lista de resumos aceptados para la nueva llamada "Efectos urbanos y'
        + ' regionales y políticas públicas derivadas de COVID-19" se encuentra en:</b>'
        + '<u><a target="_blank" href="http://www.civil.uminho.pt/planning/pluris2020/Lista_de_resumos_covid_aprovados_2020_ES.pdf">'
        + ' http://www.civil.uminho.pt/planning/pluris2020/Lista_de_resumos_covid_aprovados_2020_ES.pdf</a></u><br><br>'

        + '"Cualquier pregunta relacionada con la aprobación de resúmenes y artículos debe'
        + ' dirigirse al correo electrónico específico de la coordinación científica permanente:'
        + ' <u><a>pluriscientifico@gmail.com</a></u>"<br><br>'
        + 'Los artículos completos deben enviarse antes del <b>8 de septiembre de 2020.</b>'
        + ' Consulte la plantilla para formatear los artículos en la pestaña "Envío de artículos".',
      },
      {
        text: 'Todos los autores cuyos resúmenes pasaron ​a ​la fase de evaluación del'
        + ' Trabajo Completo deben enviar sus artículos para dar continuidad al proceso'
        + ' de evaluación.<br><br>'
        + 'Cabe señalar que solamente serán considerados para el evento los trabajos'
        + ' aceptados en la segunda etapa de evaluación.<br><br>'
        + 'Los trabajos completos deben ser enviados hasta el día <b>8 de septiembre de 2020</b>.<br><br>'
        + 'Todos los autores deben seguir las normas definidas en las instrucciones para'
        + ' los autores disponibles en los siguientes archivos:<br><br>'
        + '<strike>Archivo en PDF (nuevo)</strike><br>'
        + '<strike>Archivo en WORD (nuevo)</strike><br><br>'
        + 'El tamaño máximo del Trabajo Completo es de 12 páginas (incluyendo figuras,'
        + ' tablas y referencias) y deben estar conforme a las normas definidas en las'
        + ' instrucciones para los autores.<br><br>'
        + 'Resaltamos que los artículos que estén por'
        + ' encima de este límite serán rechazados, independientemente de la calidad, no'
        + ' serán considerados y ni siquiera serán revisados por el comité evaluador.<br><br>'
        + 'Para el envió de los artículos completos, por favor, haga clic en el link:<br><br>'
        + '<strike>Formulario para el envío de artículos completos</strike>',
      },
      {
        text: 'La lista de los trabajos completos aceptados se encuentra en:<br>'
        + '<a href="http://www.civil.uminho.pt/planning/pluris2020/Lista_de_artigos_aprovados_2021.pdf" target="_blank">http://www.civil.uminho.pt/planning/pluris2020/Lista_de_artigos_aprovados_2021.pdf</a>'
        + '<br><br><b>"Cualquier pregunta relacionada con la aprobación de los trabajos completos debe'
        + ' dirigirse al correo electrónico específico de la coordinación científica permanente: '
        + '<a href="#">pluriscientifico@gmail.com</a>"</b><br><br>'
        + 'Los trabajos completos deben ser enviados hasta el <b>10 de diciembre de 2020.</b>'
        + ' Revise la plantilla para dar formato a los artículos en la pestaña "<b>Envío de artículos</b>".<br><br>'
        + '<b>ADVERTENCIA:</b> Sólo los trabajos aceptados (oral o póster) con autores inscritos en el'
        + ' evento serán publicados en los anales de PLURIS 2021.<br><br>'
        + 'Los autores inscritos en la <b>categoría profesional</b> pueden registrar <b>hasta dos artículos.</b><br><br>'
        + 'Los autores registrados en la <b>categoría de estudiantes (posgrado o tercer ciclo)</b> pueden'
        + ' registrar <b>un artículo.</b><br><br>'
        + '<b>Los autores que han aprobado más artículos:</b><br><br>'
        + 'Para los autores inscritos en la categoría profesional con más de dos artículos o autores'
        + ' inscritos en la categoría de estudiantes (posgrado o tercer ciclo) con más de un artículo, <b>uno'
        + ' de los coautores deben inscribirse para haber asegurada la publicación en los anales del evento.</b><br><br>'
        + ' No se garantiza la publicación de artículos cuyos autores practiquen la inscripción después del <b>29 de enero de 2021</b>.',
      },
      {
        text: '<b>Normas para apresentação assíncrona e síncrona</b>'
        + '<br><br>Disponibilizamos, de forma sugestiva, o modelo para formatação das lâminas'
        + ' (slides) dos trabalhos aprovados no 9º Congresso Luso Brasileiro para o'
        + ' Planejamento Urbano, Regional, Integrado e Sustentável – PLURIS 2021'
        + ' DIGITAL para apresentações assíncrona e síncrona.<br><br>'
        + 'Modelo apresentação - <a href="/template_pluris.pptx" download>'
        + 'Clique aqui.</a>',
      },
    ],
    items4: [
      {
        text: 'Los valores Individual (en reales).',
        titleH1: '<b>Hasta el 29 de <br> enero de 2021</b>',
        titleH2: '<b>Después del 29 de <br> enero de 2021 o <br> en el evento</b>',
        titleV1: '<b>Profesional<br></b> (con derecho a registrar 2 trabajos)',
        titleV2: '<b>Estudiante de posgrado<br></b> (con derecho a registrar 1 trabajo)',
        titleV3: '<b>Estudiante de tercer ciclo<br></b> (con derecho a registrar 1 trabajo)',
        information: '<br><br><b>INFORMACIONES:</b><br><br>'
        + 'Los estudiantes deben demostrar su condición con documento válido expedido por los '
        + 'colegios o universidades respectivas.<br><br>',
        subscribe: 'REGISTRARSE AQUÍ',
      },
    ],
    items5: [
      {
        text: '<b>31 de octubre de 2019</b> | 1ª convocatoria de trabajos.<br><br>'
        + ' <b>25 de noviembre de 2019</b> | 2ª convocatoria de trabajos.<br><br>'
        + ' <b>20 de enero de 2020</b> | 3ª convocatoria de trabajos.<br><br>'
        + ' <b>17 de febrero de 2020</b> | Fecha límite para la presentación de resúmenes.<br><br>'
        + ' <b>23 de marzo de 2020</b> | Notificación de aceptación o rechazo de resúmenes.<br><br>'
        + ' <b>08 de mayo de 2020</b> | Fecha límite para la presentación de artículos completos.<br><br>'
        + ' <b>15 de junio 2020</b> | Notificación de aceptación o rechazo de artículos completos.<br><br>'
        + ' <b>03 de agosto de 2020</b> | Fecha límite para la presentación final de artículos completos.<br><br>'
        + ' <b>10 de agosto de 2020</b> | Fecha límite para el registro de al menos un autor y fecha límite para el registro de todos los participantes que se benefician de una tasa de descuento.<br><br>'
        + ' <b>07 al 09 de octubre de 2020 | PLURIS 2020 en el Hotel Monte Real en Águas de Lindóia - São Paulo - Brasil.<br><br> </b>',
        date1: '31 de octubre de 2019',
        date2: '25 de noviembre de 2019',
        date3: '20 de enero de 2020',
        date4: '<span style="color: #939598"><strike>17 de febrero de 2020</strike></span><br>28 de febrero de 2020',
        date5: '23 de marzo de 2020',
        date6: '<span style="color: #939598"><strike>08 de mayo de 2020</strike></span>'
        + '<br>08 de septiembre de 2020',
        date7: '<span style="color: #939598"><strike>15 de junio de 2020</strike></span>'
        + '<br><b>31 de octubre de 2020</b>',
        date8: '<span style="color: #939598"><strike>03 de agosto de 2020</strike></span>'
        + '<br>10 de diciembre de 2020',
        date9: '<span style="color: #939598"><strike>10 de agosto de 2020</strike></span>'
        + '<br>29 de enero de 2021',
        date10: '<span style="color: #939598"><b><strike>07 a 09 de octubre de 2020</b></strike></span>'
        + '<br><b>07 a 09 de abril de 2021</b>',
        title1: ' 1ª convocatoria de trabajos.',
        title2: ' 2ª convocatoria de trabajos.',
        title3: ' 3ª convocatoria de trabajos.',
        title4: ' Fecha límite para la presentación de resúmenes.',
        title5: ' Notificación de aceptación o rechazo de resúmenes.',
        title6: ' Fecha límite para la presentación de artículos completos.',
        title7: ' <b>Notificación de aceptación o rechazo de artículos completos.</b>',
        title8: ' Fecha límite para la presentación final de artículos completos.',
        title9: ' Fecha límite para el registro de al menos un autor y fecha límite para el registro de todos los participantes que se benefician de una tasa de descuento.',
        title10: '<b> PLURIS 2021 <strike>en el Hotel Monte Real en Águas de Lindóia - São Paulo - Brasil.</strike>'
        + ' <span style="color: #0189d0">Digital</span>.</b>',
        dateX1: '01 de junio de 2020',
        dateX2: '22 de junio de 2020',
        titleX1: 'Fecha límite para la presentación de resúmenes.',
        titleX2: 'Notificación de aceptación o rechazo de resúmenes.',
        titleNewCall: '<br><b>NUEVA LLAMADA PARA ARTÍCULOS</b>',
      },
    ],
    items6: [
      {
        date1: '31/10/2019',
        title1: 'Primera convocatoria para submision de resumenes.',
        link1: '',
        date2: '25/11/2019',
        title2: 'Segunda convocatoria para submision de resumenes.',
        link2: '',
        date3: '20/01/2020',
        title3: 'Tercera convocatoria para submision de resumenes.',
        link3: '',
        date4: '14/02/2020',
        title4: 'Nueva fecha límite para la presentación de resumenes: ',
        link4: '',
        extension4: '28 de febrero de 2020',
        date5: '23/03/2020',
        link5: '',
        title5: 'Notificación de aceptación o rechazo de resúmenes. ',
        date6: '27/03/2020',
        link6: 'Accede aquí.',
        coord6: [3, 3],
        title6: 'La plantilla para formatear el texto completo está disponible en Envíos > Envío de Artículos: ',
        date7: '07/04/2020',
        link7: 'Accede aquí.',
        coord7: [3, 3],
        title7: 'El link para envio del texto completo está disponible en Envíos > Envío de Artículos:',
        date8: '04/05/2020',
        link8: '',
        title8: 'Debido a la pandemia causada por COVID-19, asociada con la'
        + ' incertidumbre actual sobre cuándo se mitigará la situación, el comité'
        + ' organizador de PLURIS 2020 decidió transferir el congreso al período del 7 al 9'
        + ' de abril de 2021. Por lo tanto, tiene la intención de cumplir con el directrices de '
        + ' la Organización Mundial de la Salud, con el fin de reducir los riesgos asociados'
        + ' con la aglomeración de personas.',
        date9: '04/05/2020',
        link9: 'Accede aquí.',
        coord9: [5, 0],
        title9: 'Nuevas fechas del PLURIS 2021.',
        date10: '04/05/2020',
        link10: 'Accede aquí.',
        coord10: [3, 1],
        title10: 'Nueva llamada de trabajos, solamente para el tema'
        + ' "Efectos urbanos y regionales y políticas públicas derivadas de COVID-19".',
        date11: '04/05/2020',
        link11: 'Accede aquí.',
        coord11: [3, 3],
        title11: 'La nueva plantilla está disponible en Envíos > Envío de Artículos.',
        date12: '22/06/2020',
        link12: 'Accede aquí.',
        coord12: [3, 2],
        title12: 'Notificación de aceptación o rechazo de resúmenes.',
        date13: '30/09/2020',
        link13: '',
        title13: 'Informamos que la notificación de los resultados de la revisión de los trabajos'
        + ' completos presentados a PLURIS 2021 se ha extendido hasta el 31 de octubre de 2020.',
        date14: '31/10/2020',
        link14: 'Accede aquí.',
        coord14: [3, 4],
        title14: 'Notificación de aceptación o rechazo de artículos completos.',
        date15: '31/10/2020',
        link15: '',
        title15: 'Debido a la continua incertidumbre con respecto a la pandemia de COVID-'
        + ' 19, el comité organizador de PLURIS 2021 decidió cambiar el congreso para el formato'
        + ' digital. Se anunciarán nuevas tarifas de inscripción, así como se redactará un nuevo'
        + ' programa de eventos, pero las fechas permanecen sin cambios (7-9 de abril de 2021).',
        date16: '12/11/2020',
        link16: '',
        title16: 'Los autores deben actualizar el template del artículo para la nueva versión, ya'
        + ' que se ha cambiado el encabezado.'
        + '<a href="/template_pluris_es.docx" download>Accede aquí.</a>'
        + ' El envío de los trabajos finales debe realizarse a través del link individual'
        + '  que el comité científico envió a cada autor por correo electrónico.',
        date17: '27/11/2020',
        link17: 'Accede aquí.',
        coord17: [4, 0],
        title17: 'Las suscripciones para PLURIS 2021 están abiertas!',
        date18: '04/03/2021',
        link18: 'Accede aquí.',
        coord18: [3, 5],
        title18: 'Para obtener la plantilla de formato de presentación: ',
        date19: '05/03/2021',
        link19: '',
        title19: 'Saiba como será o PLURIS 2021 totalmente digital! ',
        date20: '08/03/2021',
        link20: '',
        title20: 'O PLURIS 2021 DIGITAL está chegando e, com ele, muitas'
        + ' novidades! Saiba como será a programação científica do evento!',
        date21: '09/03/2021',
        link21: 'Clique aqui.',
        coord21: [3, 5],
        title21: 'Envie a apresentação do seu trabalho. Saiba mais!  ',
        date22: '18/03/2021',
        link22: '',
        title22: 'Nota de Falecimento Profa Júlia Lourenço',
        date23: '25/03/2021',
        link23: 'Clique aqui.',
        coord23: [1, 2],
        title23: 'Programação final.  ',
        date24: '05/04/2021',
        link24: 'Clique aqui.',
        coord24: [1, 5],
        title24: 'Confira a Versão Preliminar dos Anais do PLURIS 2021.',
        date25: '06/04/2021',
        link25: '',
        title25: 'Confira a Programação Final dos Painéis Temáticos.</b> <a href="/programacao_paineis.pdf" download>Clique aqui.</a>',
        date26: '06/04/2021',
        link26: '',
        title26: 'PARA TER ACESSO À PLATAFORMA VIRTUAL DO PLURIS 2021,'
        + '<a href="https://plurisdigital.ciente.live/login/"'
        + ' target="_blank">CLIQUE AQUI.</a>',
        date27: '12/05/2021',
        link27: 'clique aqui.',
        coord27: [1, 6],
        title27: 'Para acessar os certificados do PLURIS 2021, ',
        date28: '<b>21/05/2021</b>',
        link28: 'clique aqui.',
        coord28: [1, 5],
        title28: '<b>Para acessar a versão definitiva dos Anais do PLURIS 2021, </b> ',
      },
    ],
  },
};
